export const GET_ORGANIZATION_LIST_FAIL = "GET_ORGANIZATION_LIST_FAIL";
export const GET_ORGANIZATION_LIST_REQUEST = "GET_ORGANIZATION_LIST_REQUEST";
export const GET_ORGANIZATION_LIST_SUCCESS = "GET_ORGANIZATION_LIST_SUCCESS";

export const GET_USERS_LIST_FAIL = "GET_USERS_LIST_FAIL";
export const GET_USERS_LIST_REQUEST = "GET_USERS_LIST_REQUEST";
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS";

export const GET_CONTEST_LIST_FAIL = "GET_CONTEST_LIST_FAIL";
export const GET_CONTEST_LIST_REQUEST = "GET_CONTEST_LIST_REQUEST";
export const GET_CONTEST_LIST_SUCCESS = "GET_CONTEST_LIST_SUCCESS";


export const GET_SUPPORT_REQUEST_LIST_FAIL = "GET_SUPPORT_REQUEST_LIST_FAIL";
export const GET_SUPPORT_REQUEST_LIST_REQUEST = "GET_SUPPORT_REQUEST_LIST_REQUEST";
export const GET_SUPPORT_REQUEST_LIST_SUCCESS = "GET_SUPPORT_REQUEST_LIST_SUCCESS";

export const UPDATE_SUPPORT_REQUEST_STATUS_FAIL = "UPDATE_SUPPORT_REQUEST_STATUS_FAIL";
export const UPDATE_SUPPORT_REQUEST_STATUS_REQUEST = "UPDATE_SUPPORT_REQUEST_STATUS_REQUEST";
export const UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS = "UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS";


export const GET_NEWS_LETTER_LIST_FAIL = "GET_NEWS_LETTER_LIST_FAIL";
export const GET_NEWS_LETTER_LIST_REQUEST = "GET_NEWS_LETTER_LIST_REQUEST";
export const GET_NEWS_LETTER_LIST_SUCCESS = "GET_NEWS_LETTER_LIST_SUCCESS";


export const GET_MEETING_SLOT_FAIL = "GET_MEETING_SLOT_FAIL";
export const GET_MEETING_SLOT_REQUEST = "GET_MEETING_SLOT_REQUEST";
export const GET_MEETING_SLOT_SUCCESS = "GET_MEETING_SLOT_SUCCESS";

export const CREATE_MEETING_SLOT_FAIL = "CREATE_MEETING_SLOT_FAIL";
export const CREATE_MEETING_SLOT_REQUEST = "CREATE_MEETING_SLOT_REQUEST";
export const CREATE_MEETING_SLOT_SUCCESS = "CREATE_MEETING_SLOT_SUCCESS";

export const GET_SALE_INQUIRY_FAIL = "GET_SALE_INQUIRY_FAIL";
export const GET_SALE_INQUIRY_REQUEST = "GET_SALE_INQUIRY_REQUEST";
export const GET_SALE_INQUIRY_SUCCESS = "GET_SALE_INQUIRY_SUCCESS";

export const UPDATE_DEMO_MEETING_STATUS_FAIL = "UPDATE_DEMO_MEETING_STATUS_FAIL";
export const UPDATE_DEMO_MEETING_STATUS_REQUEST = "UPDATE_DEMO_MEETING_STATUS_REQUEST";
export const UPDATE_DEMO_MEETING_STATUS_SUCCESS = "UPDATE_DEMO_MEETING_STATUS_SUCCESS";

export const SIGNOUT="SIGNOUT"

export const GET_ORGANIZATION_DETAILS_REQUEST = "GET_ORGANIZATION_DETAILS_REQUEST";
export const GET_ORGANIZATION_DETAILS_SUCCESS = "GET_ORGANIZATION_DETAILS_SUCCESS";
export const GET_ORGANIZATION_DETAILS_FAIL = "GET_ORGANIZATION_DETAILS_FAIL";

export const GET_ORG_PAYMENT_DETAILS_REQUEST =
  "GET_ORG_PAYMENT_DETAILS_REQUEST";
export const GET_ORG_PAYMENT_DETAILS_SUCCESS =
  "GET_ORG_PAYMENT_DETAILS_SUCCESS";
export const GET_ORG_PAYMENT_DETAILS_FAIL = "GET_ORG_PAYMENT_DETAILS_FAIL";

export const ACTIVATE_EVAL_PROMO_REQUEST = "ACTIVATE_EVAL_PROMO_REQUEST";
export const ACTIVATE_EVAL_PROMO_SUCCESS = "ACTIVATE_EVAL_PROMO_SUCCESS";
export const ACTIVATE_EVAL_PROMO_FAIL = "ACTIVATE_EVAL_PROMO_FAIL";

export const DEACTIVATE_ORGANIZATION_REQUEST =
  "DEACTIVATE_ORGANIZATION_REQUEST";
export const DEACTIVATE_ORGANIZATION_SUCCESS =
  "DEACTIVATE_ORGANIZATION_SUCCESS";
export const DEACTIVATE_ORGANIZATION_FAIL = "DEACTIVATE_ORGANIZATION_FAIL";

export const DEACTIVATE_BREW_USER_REQUEST = "DEACTIVATE_BREW_USER_REQUEST";
export const DEACTIVATE_BREW_USER_SUCCESS = "DEACTIVATE_BREW_USER_SUCCESS";
export const DEACTIVATE_BREW_USER_FAIL = "DEACTIVATE_BREW_USER_FAIL";

export const GET_ORG_MEMBERS_LIST_REQUEST = "GET_ORG_MEMBERS_LIST_REQUEST";
export const GET_ORG_MEMBERS_LIST_SUCCESS = "GET_ORG_MEMBERS_LIST_SUCCESS";
export const GET_ORG_MEMBERS_LIST_FAIL = "GET_ORG_MEMBERS_LIST_FAIL";

export const ASSIGN_ACCOUNT_MANAGER_REQUEST = "ASSIGN_ACCOUNT_MANAGER_REQUEST";
export const ASSIGN_ACCOUNT_MANAGER_SUCCESS = "ASSIGN_ACCOUNT_MANAGER_SUCCESS";
export const ASSIGN_ACCOUNT_MANAGER_FAIL = "ASSIGN_ACCOUNT_MANAGER_FAIL";
export const ASSIGN_ACCOUNT_MANAGER_RESET = "ASSIGN_ACCOUNT_MANAGER_RESET";

export const REMOVE_ACCOUNT_MANAGER_REQUEST = "REMOVE_ACCOUNT_MANAGER_REQUEST";
export const REMOVE_ACCOUNT_MANAGER_SUCCESS = "REMOVE_ACCOUNT_MANAGER_SUCCESS";
export const REMOVE_ACCOUNT_MANAGER_FAIL = "REMOVE_ACCOUNT_MANAGER_FAIL";

export const CREATE_ORGANIZATION_REQUEST = "CREATE_ORGANIZATION_REQUEST";
export const CREATE_ORGANIZATION_SUCCESS = "CREATE_ORGANIZATION_SUCCESS";
export const CREATE_ORGANIZATION_FAIL = "CREATE_ORGANIZATION_FAIL";
export const CREATE_ORGANIZATION_RESET = "CREATE_ORGANIZATION_RESET";

export const GET_ORG_PRICING_REQUEST = "GET_ORG_PRICING_REQUEST";
export const GET_ORG_PRICING_SUCCESS = "GET_ORG_PRICING_SUCCESS";
export const GET_ORG_PRICING_FAIL = "GET_ORG_PRICING_FAIL";

export const GET_ORG_PRICING_HISTORY_REQUEST =
  "GET_ORG_PRICING_HISTORY_REQUEST";
export const GET_ORG_PRICING_HISTORY_SUCCESS =
  "GET_ORG_PRICING_HISTORY_SUCCESS";
export const GET_ORG_PRICING_HISTORY_FAIL =
  "GET_ORG_PRICING_HISTORY_FAIL";

export const ORG_PRICING_MUTATION_REQUEST =
  "ORG_PRICING_MUTATION_REQUEST";
export const ORG_PRICING_MUTATION_SUCCESS =
  "ORG_PRICING_MUTATION_SUCCESS";
export const ORG_PRICING_MUTATION_FAIL =
  "ORG_PRICING_MUTATION_FAIL";
export const ORG_PRICING_MUTATION_RESET =
  "ORG_PRICING_MUTATION_RESET";